/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Pagination_PrevInputs */

const vi_sl_pagination_prev = /** @type {(inputs: Sl_Pagination_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang trước`)
};

/**

* @param {Sl_Pagination_PrevInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_pagination_prev = /** @type {((inputs?: Sl_Pagination_PrevInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Pagination_PrevInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_pagination_prev(inputs)
});